import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormControl, Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../../environments/environment';
import { ApplicationService } from 'app/services/application.service';
import { PopupService } from '../../../../services/shared/popup.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PermitService } from 'app/services/permit.service';
import { VehicleService } from 'app/services/vehicle.service';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, merge } from 'rxjs/operators';
import { PlaceService } from 'app/services/place.service';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { DocumenttypeService } from 'app/services/documenttype.service';
import { RouteService } from 'app/services/route.service';
import { CountryService } from 'app/services/country.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { PermitTypeService } from 'app/services/permit-type.service';

@Component({
  selector: 'app-app-route',
  templateUrl: './app-route.component.html',
  styleUrls: ['./app-route.component.css'],
  providers: [PlaceService, RouteService]
})
export class AppRouteComponent implements OnInit {
  @Input() dataCntrl: any;
  @Input() routeCtrl: any = { isNew: false, btnRadio: null, rLeg: {} };
  form: UntypedFormGroup;
  model: any = [];
  tabload: boolean = false;
  public pageload = false;
  disableBtn: boolean = false;
  selectedStartCoutry: any;
  isPermitApplication : boolean = false;

  @ViewChild('instance') instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  places: any = [];
  routes: any = [];
  ownRoutes: any = [];
  countries: any = [];
  selectedRadio: boolean = false;
  route_detail: any;
  start: any;
  end: any;
  defaultValue: string = '';
  selectedRoute: any;
  placeSelected: any = [];
  //btnRadio: any;
  selectedEndCoutry: any;
  placeEndSelected: any = [];
  defaultStartCoutry: any;
  defaultEndCoutry: any;

  selectedEndPlace: any;
  selectedStartPlace: any;
  defaultStartPlace: any;
  defaultEndPlace: any;

  default: any;

  isCheck: boolean = false;
  checkDelete: boolean = false;
  isProcess: boolean = true;
  selectedRouteId: any;
  message = '';
  isDuplicateMode: boolean = false;
  replaceVehicle: boolean = false;
  isStandard:boolean=false;
  isCorrection:boolean=false;
  isLongTermCorrection:boolean=false;
  frghtPass = '';

  constructor(private formBuilder: UntypedFormBuilder, private toastr: ToastrService,
    private showModal: PopupService, public applicationService: ApplicationService,
    private router: Router, private permitService: PermitService,
    private vehicleService: VehicleService, private permitTypeService: PermitTypeService,
    private utility: UtilityServiceService,
    private activeRoute: ActivatedRoute, private placeService: PlaceService,
    private documenttypeService: DocumenttypeService, private routeService: RouteService, private countryService: CountryService) {
    this.toastr.clear();

  }

  ngOnInit() {
    //////alert(this.dataCntrl.application.id); 
    this.isDuplicateMode = this.router.url.indexOf('duplicate') > 0;
    //this.routeCtrl = { isNew:true };
    if (this.router.url.indexOf('view') > 0) {
      this.isProcess = false;
      //////alert('1');
      this.checkDelete = true;
      this.isCheck = true;
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];

        //////alert(this.dataCntrl.application.id); 
        
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          //this.disableBtn = true;
          ////console.log('This is Admin')
        }
      });
    }
    if (this.router.url.indexOf('edit') > 0 || this.router.url.indexOf('duplicate') > 0) {
      if(this.router.url.indexOf('duplicate') > 0){
        this.isStandard=true;
      }
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        this.dataCntrl.application.id = this.dataCntrl.application.id == null || this.dataCntrl.application.id == undefined? this.dataCntrl.permits[0].application_id : this.dataCntrl.application.id;
        ////console.log('Application ID :', params['id']);
        if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
          this.disableBtn = true;
          ////console.log('This is Admin')
        }
      });

    }
    if(this.router.url.indexOf('change') > 0){
      if(this.activeRoute.params['_value'].ctrlType!=undefined && this.activeRoute.params['_value'].ctrlType=='vehicle'){
        this.replaceVehicle=true;
        this.isStandard=true;
      }
    }

    if(this.dataCntrl.application.id != null && this.dataCntrl.application.id > 0)
    {
      this.isPermitApplication = true;
    }

    this.dataCntrl.changeRoute=false;
    this.initForm();
    // this.getPlaces();

    // simulate radio button '1' clicked. radio buttons have been 'removed'
    this.routeCtrl.btnRadio = '1'
    // this.optionOneEvent();
    // this.isCheck = true;
    // this.defaultValue = 'Select route';
    // this.selectedRoute = 'Select route';
    // this.isStandard=true;
    // this.dataCntrl.isStandard=true;

    //this.clickOptionOne();
    
    this.frghtPass = this.dataCntrl.permittype.freight_passenger_ind == 1 ? 'A' : 'B';
    this.PopulateRouteDropDown();
    this.model = this.dataCntrl;
    
    // ////alert(this.isCheck);
    // ////alert(JSON.stringify(this.routes));
    this.checkIfLongTermPermit();

    
    ////console.log('Route data :', this.routeCtrl);
  }

  LoadPermitRouteData(application)
  {
    
    this.form.patchValue({
     
      route_detail: application.route_detail,
      route_summary: application.route_summary,
      description: application.route_summary,
     
    });

    if(application.route_summary == null || application.route_summary == undefined )
    { 
      this.selectedRoute = "Select route";
      this.defaultValue = "";
    }    
  }

clickOptionOne() {
  // if (event.target.value === '1') {
    // this.form.reset();
    this.isCheck = false;
    this.checkDelete = false;

    this.frghtPass = this.dataCntrl.permittype.freight_passenger_ind == 1 ? 'A' : 'B';

    this.getPlaces();
    this.defaultValue = '';
    this.form.patchValue({
      id: '',
      route_name: 'Select route',
      route_detail: '',
      route_summary: '',
      code: '',
      description: '',
    });
    this.selectedRoute = 'Select route';

    if (this.dataCntrl.application.status_id != '1') {
      this.isStandard=true;
      this.dataCntrl.isStandard=true;
    }

  // }
  }

  initForm() {
    this.form = this.formBuilder.group({
      id: [0, []],
      btnRadio: ['', [<any>Validators.required]],
      route_name: ['', [<any>Validators.required]],
      code: ['', [<any>Validators.required]],
      route_detail: ['', [<any>Validators.required]],
      route_summary: ['', [<any>Validators.required]],
      description: ['', [<any>Validators.required]],
    });
  }
  formatter = (x: { name: string }) => x.name;


  getSelectedEnd(event) {
    let country = this.countries.find(x => x.desc == event.item)
    let obj = this.places.find(x => x.country_id == country.id);
    let id = obj.id;
    ////console.log(id);
    this.end = id;

  }
  getSelectedStart(event) {

    let country = this.countries.find(x => x.desc == event.item)
    let obj = this.places.find(x => x.country_id == country.id);
    let id = obj.id;
    this.start = id;
    ////console.log(id);

  }
  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? this.countries.map(v => v.desc)
        : this.countries.map(v => v.desc).filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)),);
  //desc
  search2 = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? this.routes.map(v => v.route_detail)
        : this.routes.map(v => v.route_detail).filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)),);


  getSelectedR(event) {
    //////console.log(event.item);
    let obj = this.routes.find(x => x.route_detail === event.item);
    //////console.log(obj);
    this.loadDataFromDatabase(obj);
  }
  checked() {
    ////console.log(this.selectedRoute);
    this.default = '';
    this.routeService.getMyRoute(this.selectedRoute.id).subscribe((data: any) => {
      ////console.log(data)
      
      ///this.selectedRoute = data.description;
      
      // this.getOption1Leg(this.selectedRoute.id);
      this.loadDataWhenSelected(data);

    });

  }
  checkedStartRoute() {
    ////console.log(this.selectedStartCoutry)
    this.placeSelected = null;
    ////console.log(this.places.filter(x => x.country_id == this.selectedStartCoutry.id))
    this.placeSelected = this.places.filter(x => x.country_id == this.selectedStartCoutry.id);
  }
  checkedEndRoute() {
    ////console.log(this.selectedEndCoutry)
    this.placeEndSelected = null;
    ////console.log(this.places.filter(x => x.country_id == this.selectedEndCoutry.id))
    this.placeEndSelected = this.places.filter(x => x.country_id == this.selectedEndCoutry.id);
  }
  getPlaces() {
    this.pageload = true;
    this.message = 'Loading standard routes, please wait...';
    let groupCode = this.frghtPass;
    this.routeService.getAllRoute().subscribe(data => {
      //////console.log(data);

      let tmpRoutes: any = data;
      this.routes = tmpRoutes.filter(route => route.group_code == groupCode);

      // this.routes = data;
      this.pageload = false;
      ////console.log(this.routes)
      //  ////console.log(this.routes.map(v => v.route_detail));
    }, error => {
      this.toastr.info('No standard routes found', 'Standard Routes');
      ////console.log('Error : ', error);
      this.pageload = false;
    });

  }
  PopulateRouteDropDown() {
    this.pageload = true;
    // // if (this.dataCntrl.application.route_id != null) {
    // //   this.routeService.getMyRoute(this.dataCntrl.application.route_id).subscribe((data: any) => {
        
    //     this.routeService.getDoNotBelong().subscribe((data: any) => {
    //       ////console.log(data);
    //       //this.ownRoutes = data.filter(x => x.user_created == environment.authWebApi.userData.User.FirstName);
    //       let newArr = []
    //       data.forEach((item, index) => {
    //         if (newArr.findIndex(i => i.description == item.description) === -1) {
    //           newArr.push(item)
    //         }

    //       });

    //       let tmpRoutes: any = newArr;
    //       this.ownRoutes = tmpRoutes.filter(route => route.group_code == this.frghtPass)
    //       this.routes = this.ownRoutes;
    //       // this.ownRoutes = newArr
    //     });
    //     // this.defaultValue = data.description;
    //     // this.selectedRoute = data.description;
    //     // this.selectedRouteId = data.id;
    //     this.isCheck = true;
    //     this.checkDelete = true;
    //     // ////console.log(this.defaultValue)
    //     // this.loadDataFromDatabase(data);




    //   // }, error => {
    //   //   this.routeService.getDoNotBelong().subscribe((data: any) => {
    //   //     ////console.log(data);
    //   //    // this.ownRoutes = data.filter(x => x.user_created == environment.authWebApi.userData.User.FirstName);
    //   //     let newArr = []
    //   //     data.forEach((item, index) => {
    //   //       if (newArr.findIndex(i => i.description == item.description) === -1) {
    //   //         newArr.push(item)
    //   //       }

    //   //     });

    //   //     let tmpRoutes: any = newArr;
    //   //     this.ownRoutes = tmpRoutes.filter(route => route.group_code == this.frghtPass)
    //   //     this.routes = this.ownRoutes;
    //   //   });
    //   //   this.selectedRoute = 'Select route';
    //   //   this.checkDelete = false;


    //   // })

    // }

    //if (this.dataCntrl.application.route_id == null) {
      this.routeService.getDoNotBelong().subscribe((data: any) => {
        ////console.log(data);
        //this.ownRoutes = data.filter(x => x.user_created == environment.authWebApi.userData.User.FirstName);
        let newArr = []
        data.forEach((item, index) => {
          if (newArr.findIndex(i => i.description == item.description) === -1) {
            newArr.push(item)
          }

        });

        ////alert(JSON.stringify(newArr));
        let tmpRoutes: any = newArr;
        this.ownRoutes = tmpRoutes.filter(route => route.group_code == this.frghtPass);
        this.routes = this.ownRoutes;
        
        //alert('2');
        this.defaultValue = '';
        //alert(this.selectedRoute);
        // this.ownRoutes = newArr

        this.routes.forEach(r => {
          if(r.id === this.dataCntrl.application.route_id)
          {
            this.selectedRoute = r;           
          }
        });

        if(this.isPermitApplication == true)
        {
          //this.selectedRoute = this.dataCntrl.application.route_summary;
          this.LoadPermitRouteData(this.dataCntrl.application);
        }

        this.pageload = false;
      });
      //this.selectedRoute = this.selectedRoute;
     
    //}
    //

  }

  // checkOption(event) {
  //   ////console.log('Option : ', event.target.value)
  //   if (event.target.value === '2') {
  //     this.isStandard=false;
  //     this.isCheck = true;
  //     this.form.patchValue({
  //       id: '',
  //       route_name: '',
  //       route_detail: '',
  //       route_summary: '',
  //       code: '',
  //       description: '',
  //     });
  //     //this.getCustomRoute1();
  //     this.dataCntrl.isStandard=false;
  //    // this.loadUserCreatedRoutes(true);
  //   }
  //   if (event.target.value === '1') {
  //     // this.form.reset();
  //     this.isCheck = false;
  //     this.checkDelete = false;

  //     this.getPlaces();
  //     this.defaultValue = '';
  //     this.form.patchValue({
  //       id: '',
  //       route_name: 'Select route',
  //       route_detail: '',
  //       route_summary: '',
  //       code: '',
  //       description: '',
  //     });
  //     this.selectedRoute = 'Select route';
  //     this.isStandard=true;
  //     this.dataCntrl.isStandard=true;
  //   }
  //   if (event.target.value === '3') {
  //     // this.form.reset();
  //     this.routeCtrl.isNew = true ;
  //     //this.routeCtrl.btnRadio = null;
  //     this.isCheck = false;
  //     this.checkDelete = false;
  //     //this.getPlaces();
  //     this.defaultValue = '';
  //     this.isStandard=false;
  //     this.form.patchValue({
  //       id: '',
  //       route_name: '',
  //       route_detail: '',
  //       route_summary: '',
  //       code: '',
  //       description: ''
  //     });
  //     this.dataCntrl.isStandard=false;
  //   }
  //   //  this.defaultValue = 'Select route';
  // }
  loadDataWhenSelected(route: any) {
    this.form.patchValue({
      // id:route.id,
      route_detail: route.route_detail,
      route_summary: route.route_summary,
      code: route.code,
      description: route.description,
      // num_countries: route.num_countries,
      // num_border_crossings: route.num_border_crossings,


    });
  }
  loadDataFromDatabase(route: any) {
    //////console.log('Route Selected :', route);
    this.routeCtrl.rLeg.route_summary = route.route_summary;
    this.routeCtrl.rLeg.code = route.code;
    this.routeCtrl.rLeg.route_detail = route.route_detail;
    if(this.dataCntrl.isStandard){
      this.isStandard=true;
    }
    this.form.patchValue({
      // id:route.id,
      // route_name:route.description,
      code: route.code,
      route_detail: route.route_detail,
      route_summary: route.route_summary,
      description: route.description,
      // num_countries: route.num_countries,
      // num_border_crossings: route.num_border_crossings,


    });
  }
  changes() {
    this.form.statusChanges.subscribe(
      result =>
        this.dataCntrl.formValid = result == 'VALID' ? true : false
    );
  }

  saveRoute() {
    //////console.log(this.form.value.description);
//alert(this.form.value.description);
    if (!this.form.value.description) {
      return this.toastr.warning('Please Enter a name for the route that is easy to remember (e.g. Harare to Joburg)"');
    }
    if (!this.form.value.route_summary) {
      return this.toastr.warning('Please Enter a short description of the route (e.g. Harare to Joburg via Bulawayo)"');
    }
    // if (!this.form.value.code) {
    //   return this.toastr.warning('Please Enter a unique identifier for this route (e.g. HREJHB01)');
    // }

    // if (!this.form.value.route_detail) {
    //   return this.toastr.warning('Enter a detailed description of the whole route, indicating all the stopping points and border posts');
    // }
    // if(this.form.value.endPlace === 'Select place'){
    //   return this.toastr.warning('Please choose your end place route');
    // }

    // if(this.form.value.btnRadio === '3'){
    //    this.saveDepatureDestination();
    //    return
    // }
    let id: any = ""
    if (this.selectedRoute.hasOwnProperty('id')) {
      id = this.selectedRoute.id;
    } else {
      id = this.selectedRouteId;
    }

    let route = {
      id: id,
      code: this.form.value.code + '-' + this.dataCntrl.application_id,
      route_detail: this.form.value.route_detail,
      description: this.form.value.description,
      route_summary: this.form.value.route_summary,
      // num_countries:this.form.value.num_countries,
      // num_border_crossings:this.form.value.num_border_crossings,
      user_created: environment.authWebApi.userData.User.FirstName,
      user_modified: environment.authWebApi.userData.User.FirstName,
      date_created: new Date(),
      date_modified: new Date(),
    }

    // ////console.log(route);
    // ////console.log(this.dataCntrl.application)

    if (route.code.length > 12) {
      route.code = route.code.substr(0, 12)
    }
    //if (this.dataCntrl.application.motivation_detail === null || this.dataCntrl.application.motivation_detail.length < 20) {
    //  return this.toastr.warning('Motivation must contain at least 20 characters');
    //}
    this.tabload = true;
    this.pageload = true;
    this.message = "Saving route & motivation. Please wait...";
    if (this.routeCtrl.btnRadio!=3) {
      if (this.dataCntrl.application.route_id == id && this.dataCntrl.application.route_summary == this.form.value.description && this.dataCntrl.application.route_detail == this.form.value.route_detail) {
        this.applicationService.setTab(4);
      }
      else
      {
        if(this.isPermitApplication == true)
        {                
          this.dataCntrl.application.route_id = id;
          this.dataCntrl.application.route_summary = this.form.value.description;
          this.dataCntrl.application.route_detail = this.form.value.route_detail;
         
       
          this.dataCntrl.application.permits.forEach(perm => {
            perm.route_id = id;
            perm.route_summary = this.form.value.description;
            perm.route_detail = this.form.value.route_detail;
          });
          
          
          this.applicationService.putApplication(this.dataCntrl.application)
          .subscribe(result => {
            this.pageload = false;
            this.dataCntrl.application = result;
            this.tabload = false;
            
              this.applicationService.setTab(4);
            
          },
            error => {
              this.pageload = false;
              this.tabload = false;
              this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

              // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
              return;
            });

          

        }
        else{
       
          //////console.log(x);
        //  this.updatePermit(x.id)
          //this.dataCntrl.application.route_id = x.id; 
          this.dataCntrl.application.route_summary = this.form.value.description;
          this.dataCntrl.application.route_detail = this.form.value.route_detail;
          if (this.router.url.indexOf('duplicate') > 0 && this.router.url.indexOf('edit') < 0) {
            //////console.log("duplicated");
            //////console.log(this.dataCntrl.application);
            // this.applicationService.putApplicationDuplicate(this.dataCntrl.application)
            //   .subscribe(result => {
            //     this.pageload = false;
            //     this.dataCntrl.application = result;
            //     this.tabload = false;
            //     // this.saveDepatureDestination();
            //     this.toastr.success( 'Application duplicated successfully','Duplicate Application');
            //     let url: any = "carrier/permit/application/duplicate/edit/" + result.id;
            //     this.router.navigate([url]);
            //   },
            //     error => {
            //       this.pageload = false;
            //       this.tabload = false;
            //       this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

            //       // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
            //       return;
            //     });
            this.applicationService.setTab(4);
          } else {
            this.applicationService.putApplication(this.dataCntrl.application)
              .subscribe(result => {
                this.pageload = false;
                this.dataCntrl.application = result;
                this.tabload = false;
                // // this.saveDepatureDestination();
                // this.toastr.success( 'Route saved successfully','Save Application');
                // setTimeout(() => {
                //   this.toastr.clear();
                //   //if (!this.utility.timetableActive) {
                //   //  this.applicationService.setTab(5);
                //   //} else {
                //   //  this.applicationService.setTab(4);
                //   //}
                  this.applicationService.setTab(4);
                // }, 4000);
              },
                error => {
                  this.pageload = false;
                  this.tabload = false;
                  this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

                  // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
                  return;
                });
          }


       
        }
      }
    } else {
      //alert('here');
      // this.routeCtrl.rLeg.user_created = environment.authWebApi.userData.User.FirstName;
      // this.routeCtrl.rLeg.user_modified = environment.authWebApi.userData.User.FirstName;
      // this.createApplicationPermitNewRoute(this.routeCtrl.rLeg);
    }

  }

  // saveDepatureDestination() {
  //   // if(this.form.value.btnRadio === '3'){
  //   //   return this.saveBtn3();
  //   // }

  //   let obj = {
  //     id: 0,
  //     place_to_id: this.form.value.endPlace.id,
  //     place_from_id: this.form.value.startPlace.id,
  //     route_description: this.form.value.description,
  //     application_id: +this.dataCntrl.application.id,
  //     permit_id: this.dataCntrl.permit.id,
  //     route_id: this.form.value.id,
  //     place_to: this.form.value.endRoute.desc,
  //     place_from: this.form.value.startRoute.desc,
  //     date_created: new Date(),
  //     date_modified: new Date(),
  //   }


  //   if (this.form.value.btnRadio === '2' || this.form.value.btnRadio === '1') {
  //     if (obj.place_to_id == undefined) {
  //       obj.place_to_id = this.end;
  //       // obj.place_from_id = this.start;
  //     }
  //     if (obj.place_from_id == undefined) {
  //       // obj.place_to_id = this.end;
  //       obj.place_from_id = this.start;
  //     }
  //     if (this.form.value.endRoute.desc) {
  //       this.form.value.endRoute = this.form.value.endRoute.desc
  //     }
  //     if (this.form.value.startRoute.desc) {
  //       this.form.value.startRoute = this.form.value.startRoute.desc;
  //     }
  //     obj.place_to = this.form.value.endRoute;
  //     obj.place_from = this.form.value.startRoute
  //   }
  //   ////console.log(obj);
  //   ////console.log(this.form.value);
  //   this.pageload = true;
  //   this.tabload = true;

  //   this.routeService.saveRouteLeg(obj).subscribe(x => {
  //     this.pageload = false;
  //     this.tabload = false;
  //     this.toastr.success( 'Route saved successfully','Save Application');

  //     this.applicationService.setTab(4);

  //   }, error => {
  //     this.pageload = false;
  //     this.tabload = false;
  //     this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

  //   })
  // }
  // saveBtn3() {
  //   let obj = {
  //     id: 0,
  //     place_to_id: this.form.value.endPlace.id,
  //     place_from_id: this.form.value.startPlace.id,
  //     route_description: this.form.value.description,
  //     application_id: +this.dataCntrl.application.id,
  //     permit_id: this.dataCntrl.permit.id,
  //     place_to: this.form.value.endRoute.desc,
  //     place_from: this.form.value.startRoute.desc,
  //     date_created: new Date(),
  //     date_modified: new Date(),
  //   }
  //   this.pageload = true;
  //   this.tabload = true;
  //   this.routeService.saveRouteLeg(obj).subscribe(x => {
  //     this.pageload = false;
  //     this.tabload = false;
  //     this.toastr.success( 'Route saved successfully','Save Application');

  //     this.applicationService.setTab(4);

  //   }, error => {
  //     this.pageload = false;
  //     this.tabload = false;
  //     this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

  //   })
  // }
  // savePermit() {

  //   this.dataCntrl.permit.date_modified = this.dataCntrl.permit.date_created = new Date();
  //   this.dataCntrl.permit.user_modified = this.dataCntrl.permit.user_created = environment.authWebApi.userData.User.FirstName;
  //   this.dataCntrl.permit.permit_fee = this.dataCntrl.permittype.current_fee == null ? 0 : this.dataCntrl.permittype.current_fee;
  //   this.dataCntrl.permit.application_fee = this.dataCntrl.permittype.current_application_fee == null ? 0 : this.dataCntrl.permittype.current_application_fee;
  //   this.permitService.postPermit(this.dataCntrl.permit)
  //     .subscribe(result => {
  //       this.dataCntrl.permit = result;
  //       this.tabload = false;
  //       this.toastr.success('Saved Permit Type Successfully', 'Permit Type');
  //       // this.applicationService.setTab(2);
  //     },
  //       error => {
  //         this.tabload = false
  //         this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', error)

  //         return;
  //       });
  // }
  // updatePermit(id) {
  //   this.dataCntrl.permits.
  //   this.dataCntrl.permit.route_id = id;
  //   let startDate: any = null;
  //   for (let item of this.dataCntrl.vehicles) {
  //     if (this.dataCntrl.permit.id == item.permit_id) {
  //       startDate = this.dataCntrl.vehicles[0].start_date;
  //     }
  //   }
  //   if (startDate !== null) {
  //     this.dataCntrl.permit.date_11 = new Date(startDate.split("/")[2] + "-" + startDate.split("/")[1] + "-" + startDate.split("/")[0]).toISOString();
  //   }
  //   this.permitService.upadatePermit(this.dataCntrl.permit).subscribe(result => {
  //     //alert('updated');
  //     // this.dataCntrl.permit = result;
  //     // this.toastr.success('Updated Permit Type Successfully','Permit Type');
  //     // this.applicationService.setTab(2);

  //   })

  // }

  backtoVehicle() {
    this.applicationService.setTab(2);
  }
  // deleteRoute() {
  //   this.showModal.showYesNo('Delete Route', 'Are you sure you want to delete?', `You're about to delete this route`, 'Yes', 'No')
  //     .subscribe((isConfirmed) => {
  //       if (isConfirmed) {
  //         this.delete(this.dataCntrl.application.route_id);
  //       } else {
  //         return;
  //       }
  //     });
  // }
  // delete(id) {
  //   this.routeService.deleteExternalRoute(id).subscribe((x: any) => {
  //     this.routeService.getDoNotBelong();
  //     this.dataCntrl.application.route_id = null;
  //     ////console.log(x);
  //     this.checkDelete = false;
  //     this.isCheck = false;
  //     this.toastr.success( 'Route deleted successfully','Delete Route');
  //     this.routeCtrl.rLeg.route_summary = null;
  //     this.routeCtrl.rLeg.code = null;
  //     this.routeCtrl.rLeg.route_detail = null;
  //     this.dataCntrl.application.motivation_detail = null;
  //   },
  //     error => {
  //       ////console.log(error.error.Message)
  //       this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
  //       // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
  //       return;
  //     });
  // }
  onSubmit(value) {
    //////console.log(value)
  }
  cancelApplication() {
    let prevUrl = localStorage.getItem('previousUrl');
    if (prevUrl.search('/permit/approval') != -1) {
      this.router.navigate(['/permit/approval/']);
    } else if (prevUrl.search('/carrier/permit/application/mypermits') != -1) {
      this.router.navigate(['/carrier/permit/application/mypermits/',this.dataCntrl.carrierID]);
    } else {
      this.router.navigate(['/carrier/permit/application/',this.dataCntrl.carrierID]);
    }
  }
    // if (this.dataCntrl.application.id == undefined && this.dataCntrl.application.id == null) {
      // this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
    // } else {
    //   this.showModal.showYesNo('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
    //     .subscribe((isConfirmed) => {
    //       if (isConfirmed) {
    //         this.deleteApplication()
    //       } else {
    //         return;
    //       }
    //     });
    // }
  // }
  // deleteApplication() {
  //   ////console.log("delete application");
  //   this.pageload = true;

  //   this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe(x => {
  //     ////console.log(x);
  //     this.deleteApp(this.dataCntrl.application.id);
  //     this.pageload = false;

  //     this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);

  //   })
    //this.dataCntrl.application.id
    //this.dataCntrl.permit.id
  // }
  // deletePermit(id) {
  //   this.permitService.deletePermit(id).subscribe(x => {
  //     ////console.log(x);
  //   })

  // }
  // deleteApp(id) {
  //   this.applicationService.deleteApplication(id).subscribe(x => {
  //     ////console.log(x);
  //   })
  // }
  // getOption1Leg(id) {
  //   this.placeService.getPlaces().subscribe((q: any) => {
  //     this.routeService.getAllRouteLegs().subscribe((x: any) => {
  //       ////console.log(x.filter(x => x.route_id === id));
  //       let obj = x.filter(x => x.route_id === id);
  //       ////console.log(Math.max.apply(Math, obj.map(function(o) { return o.id; })))
  //       let foundRouteLeg = obj.find(x => x.id == Math.max.apply(Math, obj.map(function(o) { return o.id; })));
  //       let routeLegFromPlace = q.find(x => x.id == foundRouteLeg.place_from_id);
  //       let routeLeToPlace = q.find(x => x.id == foundRouteLeg.place_to_id);

  //       ////console.log(foundRouteLeg.place_from)
  //       ////console.log(foundRouteLeg.place_to)
  //       this.loadRouteLeg(foundRouteLeg)
  //       this.end = routeLeToPlace.id;
  //       this.start = routeLegFromPlace.id;

  //       ////console.log(routeLegFromPlace.name);
  //       ////console.log(routeLeToPlace.name);
  //       this.loadRouteLegPlaces(routeLegFromPlace.name, routeLeToPlace.name);

  //     })

  //   });
  // }
  // getAllRouteLegs() {
  //   let accumulateCoutries: any = [];
  //   this.placeService.getPlaces().subscribe((q: any) => {
  //     this.routeService.getAllRouteLegs().subscribe((x: any) => {
  //       ////console.log(x.filter(x => x.application_id === +this.dataCntrl.application.id));
  //       let obj = x.filter(x => x.application_id === +this.dataCntrl.application.id);
  //       ////console.log(Math.max.apply(Math, obj.map(function(o) { return o.id; })))
  //       let foundRouteLeg = obj.find(x => x.id == Math.max.apply(Math, obj.map(function(o) { return o.id; })));
  //       let routeLegFromPlace = q.find(x => x.id == foundRouteLeg.place_from_id);
  //       let routeLeToPlace = q.find(x => x.id == foundRouteLeg.place_to_id);

  //       ////console.log(foundRouteLeg.place_from)
  //       ////console.log(foundRouteLeg.place_to)
  //       this.loadRouteLeg(foundRouteLeg)
  //       this.end = routeLeToPlace.id;
  //       this.start = routeLegFromPlace.id;

  //       ////console.log(routeLegFromPlace.name);
  //       ////console.log(routeLeToPlace.name);
  //       this.loadRouteLegPlaces(routeLegFromPlace.name, routeLeToPlace.name);
  //       // for(var i = 0;i<obj.length;i++){
  //       //   for(var j =0;j<q.length;j++){
  //       //     if(obj[i].place_from_id === q[j].id){
  //       //       ////console.log(q[j].id)//country_id
  //       //       ////console.log(q[j].country_id)
  //       //       ////console.log(this.countries.find(x => x.id == q[j].country_id));
  //       //       ////console.log(this.countries.filter(x => x.id == q[j].country_id))
  //       //       accumulateCoutries.push(this.countries.find(x => x.id == q[j].country_id))
  //       //     }
  //       //   }


  //       // }
  //       //  ////console.log(accumulateCoutries)
  //       //  this.countries = accumulateCoutries;
  //       //  ////console.log(this.countries);
  //       // ////console.log(obj.map(x =>x.country_id))
  //       // ////console.log(this.countries.filter(x => x.id == obj.map(x =>x.country_id)[0]))
  //       // this.countries.filter(x => x.id == obj.map(x =>x.country_id)[0])
  //       // if(obj.length >0 ){
  //       //    for(let i=0;i<obj.length;i++){
  //       //      ////console.log(obj[i])
  //       //     // this.loadRouteLeg(obj[i]);
  //       //    }
  //       // }
  //     })

  //   });

  // }
  // loadRouteLeg(data) {
  //   this.form.patchValue({
  //     endRoute: data.place_to,
  //     startRoute: data.place_from,

  //   });
  //   this.defaultStartCoutry = data.place_from;
  //   this.defaultEndCoutry = data.place_to;
  // }
  // loadRouteLegPlaces(start, end) {
  //   this.form.patchValue({
  //     startPlace: start,
  //     endPlace: end,

  //   });
  //   this.defaultStartPlace = start;
  //   this.defaultEndPlace = end;
  // }
  // deleteRouteOnUpdate() {
  //   ////console.log('deleteExternalRoute')
  //   this.routeService.deleteExternalRoute(this.dataCntrl.application.route_id).subscribe((x: any) => {
  //     this.routeService.getDoNotBelong();
  //     this.dataCntrl.application.route_id = null;
  //     ////console.log(x);
  //     this.checkDelete = false;
  //     this.isCheck = false;
  //   },
  //     error => {
  //       ////console.log(error.error.Message)
  //       this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
  //       // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
  //       return;
  //     });
  // }
  backToTab() {
    this.applicationService.setTab(2);
  }



  // getCustomRoute1() {

  //   //////alert(this.dataCntrl.application.route_id);
  //   if (this.dataCntrl.application.route_id != null) {
  //     this.routeService.getMyRoute(this.dataCntrl.application.route_id).subscribe((data: any) => {
  //       this.defaultValue = data.description;
  //       this.selectedRoute = data.description;
  //       this.selectedRouteId = data.id;
  //       this.isCheck = true;
  //       this.checkDelete = true;
  //       ////console.log(this.defaultValue)
  //       this.loadDataFromDatabase(data);
  //       this.loadUserCreatedRoutes();
  //     }, error => {
  //       this.selectedRoute = 'Select route';
  //       this.checkDelete = false;
  //     })

  //   }

  //   if (this.dataCntrl.application.route_id == null) {
  //     this.loadUserCreatedRoutes();
  //     this.selectedRoute = 'Select route';
  //     this.defaultValue = '';
  //   }

  // }

//   loadUserCreatedRoutes = (isChecked = false) => {
//     const user_created = environment.authWebApi.userData.User.FirstName;
//     //////alert(user_created);
//     this.message = (isChecked) ? 'Loading previous route, please wait...':'';
//     this.pageload = true;
//     // this.frghtPass = this.dataCntrl.permittype.freight_passenger_ind == 1 ? 'A' : 'B';
//     let groupCode = this.frghtPass;
//     this.routeService.getByUserCreated(user_created).subscribe((data: any) => {
// // ////alert(JSON.stringify(data));
// // ////alert(groupCode);
//       let tmpRoutes: any = data;
//       this.ownRoutes = tmpRoutes.filter(route => route.group_code == groupCode)

//       //////alert(JSON.stringify(this.ownRoutes));
//       // this.ownRoutes = data;
//       this.routes = this.ownRoutes;
//       ////console.log('Routes => ', this.ownRoutes);
//       this.pageload = false;
//       if (isChecked) {
//         this.selectedRoute = 'Select route';
//         this.defaultValue = '';
//       }
//     }, error => {
//       this.toastr.info('No previously used routes found', 'Reuse Route');
//       this.pageload = false;
//       this.selectedRoute = 'Select route';
//       this.defaultValue = '';
//     });
//   }

  //Can be improved if time given
//   createApplicationPermitNewRoute = (route) => {
// //alert('createApplicationPermitNewRoute');
//     this.routeService.addRouteLeg(route).subscribe((x: any) => {
//       ////console.log(x);
//       //this.updatePermit(x.id)
//       this.dataCntrl.application.route_id = x.id;
//       this.dataCntrl.application.route_summary = this.form.value.description;
//       this.dataCntrl.application.route_detail = this.form.value.route_detail;
//       if (this.router.url.indexOf('duplicate') > 0 && this.router.url.indexOf('edit') < 0) {
//         ////console.log("duplicated");
//         ////console.log(this.dataCntrl.application);
//         // this.applicationService.putApplicationDuplicate(this.dataCntrl.application)
//         //   .subscribe(result => {
//         //     this.pageload = false;
//         //     this.dataCntrl.application = result;
//         //     this.tabload = false;
//         //     // this.saveDepatureDestination();
//         //     this.toastr.success( 'Application duplicated successfully','Duplicate Application');
//         //     let url: any = "carrier/permit/application/duplicate/edit/" + result.id;
//         //     this.router.navigate([url]);
//         //   },
//         //     error => {
//         //       this.pageload = false;
//         //       this.tabload = false;
//         //       this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

//         //       // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
//         //       return;
//         //     });
//         if (!this.utility.timetableActive) {
//           this.applicationService.setTab(5);
//         } else {
//           this.applicationService.setTab(4);
//         }
//       } else {
//         this.applicationService.putApplication(this.dataCntrl.application)
//           .subscribe(result => {
//             this.pageload = false;
//             this.dataCntrl.application = result;
//             this.tabload = false;
//             // this.saveDepatureDestination();
//             this.toastr.success( 'Route and Motivation saved successfully','Save Application');
//             setTimeout(() => {
//               this.toastr.clear();
//               if (!this.utility.timetableActive) {
//                 this.applicationService.setTab(5);
//               } else {
//                 this.applicationService.setTab(4);
//               }
//             }, 4000);


//           },
//             error => {
//               this.pageload = false;
//               this.tabload = false;
//               this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

//               // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
//               return;
//             });
//       }


//     },
//       error => {
//         ////console.log(error.error.Message)
//         if (error.error.Message === 'Code already exists') {
//           this.pageload = false;
//           this.tabload = false;
//           this.toastr.error('Code already exists! Choose a different code.', 'Save Application');
//           return;
//         }
//         this.pageload = false;
//         this.tabload = false;
//         this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')

//         // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
//         return;
//       });
//   }

  checkIfLongTermPermit() {

    ////console.log(this.dataCntrl);
    if (this.router.url.indexOf('correction') > 0 || this.dataCntrl.permittype.code == 'OTH-CRR') {
      this.permitTypeService.getAll().subscribe((result:any) => {
        ////console.log(result);
        let pmtType = result.find(x => x.id == this.dataCntrl.permit.permit_type_id);
        if (pmtType.freight_passenger_ind == 2 && pmtType.temp_long_ind == 2) {
          this.isLongTermCorrection = true;
        }
      });
    }

  }
}
